import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavBar from '../AdminNavBar/AdminNavBar';

const layout = () => {
	return (
		<>
			<AdminNavBar />
			<Outlet />
		</>
	);
};

export default layout;
